import { UserResponse } from '../../common/services/user/user.model';
import UserService from '../../common/services/user/user.service';
import { IWindowService } from 'angular';
import FamilyPlanService from '../../family-plan/famil-plan.service';
import { FamilyPlanTypes } from '../../common/services/package/package.model';
import UtilService from '../../common/services/util.service';

/* @ngInject */
export default class NavBarController{
  private user: UserResponse;
  private clicked: boolean = false;
  private showFamilyPlanItem: boolean= false;
  private showDuoPlanItem: boolean= false;

  constructor(
    private userService: UserService,
    private $state,
    private $window: IWindowService,
    private familyPlanService: FamilyPlanService
  ) {


  }
  
  public $onInit() {
      this.userService.getUserInfo().then(user => {
      this.user = user;
    });
    if(window.location.href.indexOf("/family-plan-member?token=") > -1 ){
      this.showFamilyPlanItem = true;
      //TODO
      this.showDuoPlanItem = true;
    } else{
      this.familyPlanService.userHasFamilyPackage().then(result => {
        this.showFamilyPlanItem = result.family;
        this.showDuoPlanItem = result.duo;
      })
    }
  }

  public onSavedCards() {
    this.$state.go('savedCards');
  }

  public fmlyPlnAdmin() {
    this.familyPlanService.getFamilyPlanInfo(FamilyPlanTypes.FAMILY).then(familyMemberInfo => {
      if(familyMemberInfo.masterMember.userId == this.user.id){
        this.$state.go('familyPlanInfo');
      } else{
        this.$state.go('familyPlanMemberInfo');
      }
    }).catch(e =>  {
      if(this.$state.current.name !='familyPlanMember')
        this.$state.go('familyPlan');
    });
  }

  public duoPlnAdmin() {
    this.familyPlanService.getFamilyPlanInfo(FamilyPlanTypes.DUO).then(familyMemberInfo => {
      if(familyMemberInfo.masterMember.userId == this.user.id){
        this.$state.go('duoPlanInfo');
      } else{
        this.$state.go('duoPlanMemberInfo');
      }
    }).catch(e =>  {
      if(this.$state.current.name !='duoPlanMember')
        this.$state.go('duoPlan');
    });
  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  public getUserName() {
    if (!this.user) return false

    return this.user.name === '-' ? false : this.user.name
  }

  public isMsisdnValid(): boolean {
    return !!this.user && UtilService.isValidMsisdn(this.user.msisdn);
  }

  public getToogleStyle() {
    return { display: this.clicked ? 'block' : 'none' };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-bar/nav-bar.controller.ts